module.exports = __webpack_public_path__ + "img/259.e20d0b66.jpg";